/* This class is a temporary fix for sd-about component to work with new MWF js v1.7.0.
 * This class mimics the Dialog behavior for old MWF js v1.0.0 which was pulled from [ 114e5c0dcece896efd5f48808e904ff7bcd4b87a ] commit id.
 * This will be deprecated soon with the new nav bar changes
 */
export class OldMwfDialog {
  private dialog: any;
  private dialogID: any;
  private openButton: any;
  private closeButton: any;
  private closeGlyph: any;
  private dialogContent: any;
  private backdrop: any;
  private dialogInputs: any;
  private firstInput: any;
  private lastInput: any;
  private shown = false;
  private handleKeydown: (e: JQueryKeyEventObject) => void;
  // @ngInject
  constructor(private element: HTMLElement) {
    return this.init();
  }

  public show() {
    this.shown = true;
    this.dialog.setAttribute("aria-hidden", "false");
    this.dialogContent.focus();
    document.body.style.overflow = "hidden";

    let openID = this.dialogID;
    let openEl = document.getElementById(openID);
    let inputs = this.dialogInputs;
    let firstInput = inputs[0];
    let lastInput = inputs[inputs.length - 1];

    this.handleKeydown = ((e: any) => {
      let keyCode = e.keyCode || e.which;
      let target = e.target || e.srcElement;

      switch (keyCode) {
        // enter keystroke
        case 13:
          if (target.getAttribute("data-js-dialog-hide") !== undefined) {
            e.preventDefault();
            this.escape(openEl);
          }
          break;

        // escape keystroke
        case 27:
          e.preventDefault();
          this.escape(openEl);
          break;

        // tab keystroke
        case 9:
          if (inputs.length === 1) {
            e.preventDefault();
            firstInput.focus();
          } else {
            lastInput.onkeydown = function (e: any) {
              if (e.which === 9 && !e.shiftKey) {
                e.preventDefault();
                firstInput.focus();
              }
            };
            firstInput.onkeydown = function (e: any) {
              if (e.which === 9 && e.shiftKey) {
                e.preventDefault();
                lastInput.focus();
              }
            };
          }
          break;
        default:
          break;
      }
    }).bind(this);
    $(document).keydown(this.handleKeydown);
  }

  public escape(el: any) {
    this.dialog = el;
    this.hide();
  }

  public hide() {
    $(document).unbind("keydown", this.handleKeydown);
    this.shown = false;
    this.dialog.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "auto";
  }

  private init() {
    this.dialog = this.element;
    this.dialogID = this.element.getAttribute("id");
    this.openButton = document.querySelectorAll("[data-js-dialog-show=" + this.dialogID + "]");
    this.closeButton = this.element.querySelector("#" + this.dialogID + " button[data-js-dialog-hide]");
    this.closeGlyph = this.element.querySelector("#" + this.dialogID + " .c-glyph[data-js-dialog-hide]");
    this.dialogContent = this.element.querySelector("#" + this.dialogID + " div[role='dialog']");
    this.backdrop = this.element.querySelector("#" + this.dialogID + ".c-dialog div[role='presentation']");
    this.dialogInputs = this.element.querySelectorAll(
      "select, input, textarea, button, a, .c-glyph[data-js-dialog-hide]"
    );
    this.firstInput = this.dialogInputs[0];
    this.lastInput = this.dialogInputs[this.dialogInputs.length - 1];
    this.shown = false;

    if (window.addEventListener) {
      for (let i = 0; i < this.openButton.length; i++) {
        this.openButton[i].addEventListener("click", this, false);
      }
      if (this.closeButton != undefined) {
        this.closeButton.addEventListener("click", this, false);
      }
      if (this.closeGlyph != undefined) {
        this.closeGlyph.addEventListener("click", this, false);
      }
      if (this.backdrop != undefined) {
        this.backdrop.addEventListener("click", this, false);
      }
    }

    return this;
  }

  public handleEvent(e: any) {
    let target = e.target || e.srcElement;

    // dialog closing elements
    if (target == this.closeButton || target == this.closeGlyph || target == this.backdrop) {
      this.hide();
    } else if (this.openButton.length > 1) {
      for (let i = 0; i < this.openButton.length; i++) {
        if (target == this.openButton[i]) {
          this.show();
        }
      }
    } else if (target == this.openButton[0]) {
      this.show();
    }
  }
}

export class SdAbout {
  private dialog: OldMwfDialog;
  constructor() {
    this.dialog = new OldMwfDialog($("#sdaboudiv").get(0));
    $(document).on("showAboutDialog", (event: any, showDialog: boolean) => {
      if (showDialog) {
        this.dialog.show();
      } else {
        this.dialog.hide();
      }
    });
  }
}
